import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/navbar.tsx';
import { Login } from './pages/login.tsx';
import ResumeToJD from './pages/ResumeToJD.tsx';
import { JobToResumes } from './pages/JobToResumes.tsx';
import Search from './pages/search.tsx';
import Index from './pages/index.tsx';
import SearchForJob from './components/searchForJob.tsx';
import { RecruiterProvider, useRecruiter } from './context/RecruiterContext.tsx'; // Import the RecruiterProvider and useRecruiter hook
import './css/output.css';
import PrivacyPolicy from './pages/privacy_policy.tsx';
import TermsOfService from './pages/terms_of_service.tsx';
import { Onboarding } from './pages/onboarding.tsx';
import { AdJD } from './pages/add_jd.tsx';
import KanbanBoard from './components/kanban.tsx';
import ChatPage from './pages/chat_page.tsx';
import { Dashboard } from './pages/Dashboard.tsx';
import { HistoricalSearch } from './pages/HistoricalSearch.tsx';
import CandidateDashboard from './components/CandidateDashboard.tsx';
import ProfileSetupWizard from './components/ProfileSetupWizard.tsx';
import JDSetup from './components/jobdescription/jdsetup.tsx';



function App() {
  const { isLoggedIn, setIsLoggedIn } = useRecruiter(); // Access the isLoggedIn state and setIsLoggedIn function from the context
  const isRecruiter = useRecruiter(); // Access the isRecruiter state from the context
  if (isLoggedIn === null) {
    return <div>Checking authentication...</div>;
  }
  console.log("is onboard:", isRecruiter.onBoarded);
  console.log("is logged in:", isRecruiter.isLoggedIn);
  if (isLoggedIn & !isRecruiter.onBoarded) {
    return <Onboarding />;
  }

  return (
    <Layout isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn}>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/login" element={<Login />} />
        <Route path="/comparertoj" element={<ResumeToJD />} />
        <Route path="/your-job-to-resumes-path" element={isRecruiter.isLoggedIn && isRecruiter.isRecruiter ? <JobToResumes isLoggedIn={isLoggedIn} /> : <Login />} />
        <Route path="/results" element={<Search />} />
        <Route path="/upload-resume" element={<SearchForJob />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="*" element={<h1>Not Found</h1>} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/onboarding" element={isRecruiter.isLoggedIn ? <Onboarding /> : <Login />} />
        {/* <Route path="/postJob" element={<AdJD isLoggedIn={isLoggedIn} />} /> */}
        <Route path="/kanban" element={isRecruiter.isLoggedIn ? <KanbanBoard /> : <Login />} />
        <Route path="/chat" element={isRecruiter.isLoggedIn ? <ChatPage /> : <Login />} />
        <Route path="/dashboard" element={isRecruiter.isLoggedIn ? <Dashboard /> : <Login />} />
        <Route path="/historical" element={isRecruiter.isLoggedIn ? <HistoricalSearch /> : <Login />} />
        <Route path="/profile" element={isRecruiter.isLoggedIn ? <CandidateDashboard /> : <Login />} />
        <Route path="/profile/edit" element={isRecruiter.isLoggedIn ? <ProfileSetupWizard /> : <Login />} />
        <Route path="/createJd" element={<JDSetup />} />
      </Routes>
    </Layout>
  );
}




export default function AppWrapper() {
  return (
    <RecruiterProvider>
      <App />
    </RecruiterProvider>
  );
}
